import { gql } from '@apollo/client';

export const GET_MDS_DAYS_HISTORY = gql`
  query GetMDSDaysHistory($vendorNames: [String!]!) {
    getMDSDaysHistory(vendorNames: $vendorNames) {
      dateISO8601
      vendorMDSDays
      marketMDSDays
    }
  }
`;
